import { CoursesAPI } from './api-types';
import { Course } from './types';

export function courseFactory(apiCourse: CoursesAPI.APICourse): Course {
  return {
    id: apiCourse.courseId,
    code: apiCourse.code,
    title: apiCourse.title,
    canProxy: apiCourse.canProxy === 1,
    isPro: apiCourse.isPro === 1,
    courseType: apiCourse.courseType,
    enrollmentType: apiCourse.enrolmentType,
    joinCode: apiCourse.joinCode,
  };
}
